// Region detection for pricing.
// Returns one of: "IN" (India), "HK" (Hong Kong), "ROW" (Rest of World).

export const REGION_STORAGE_KEY = "yr_region";
export const VALID_REGIONS = ["IN", "HK", "ROW"];

// Guess region from the browser's IANA timezone, then locale, defaulting to ROW.
export function detectRegion() {
  try {
    const tz = Intl.DateTimeFormat().resolvedOptions().timeZone || "";
    if (tz === "Asia/Kolkata" || tz === "Asia/Calcutta") return "IN";
    if (tz === "Asia/Hong_Kong") return "HK";

    // Secondary hint: locale region subtag (e.g. en-HK, hi-IN)
    const locale = (navigator.language || "").toUpperCase();
    if (locale.endsWith("-IN")) return "IN";
    if (locale.endsWith("-HK")) return "HK";
  } catch (e) {
    // Intl unavailable — fall through to default
  }
  return "ROW";
}

// Region honouring a saved manual choice; falls back to auto-detection.
export function getInitialRegion() {
  try {
    const saved = localStorage.getItem(REGION_STORAGE_KEY);
    if (saved && VALID_REGIONS.includes(saved)) return saved;
  } catch (e) {
    // localStorage unavailable (private mode / SSR) — ignore
  }
  return detectRegion();
}

export function persistRegion(region) {
  try {
    if (VALID_REGIONS.includes(region)) {
      localStorage.setItem(REGION_STORAGE_KEY, region);
    }
  } catch (e) {
    // ignore write failures
  }
}
